import "./universal.css";
import Title from "../component/Title";
import Header from "../component/Header";
import GlobalRanking from "../component/ranking/GlobalRanking";
import { useParams } from "react-router-dom";
import Updated from "../component/Updated";

function Home() {
  const params = useParams();
  let language = params.language === undefined ? "kr" : params.language;
  const league = "GLOBAL";
  const update = "global";

  return (
    <div className="whole-container">
      <Title service="" language={language} />
      <div className="main-container">
        <div className="header-container">
          <Header service=" ELO World Ranking" league={league} />
          <Updated className="web" update={update} />
        </div>
        <Updated className="mobile" update={update} />
        <div className="ad_header" />
        <div className="content-container">
          <GlobalRanking language={language} />
        </div>
        <div className="ad_footer" />
      </div>
    </div>
  );
}

export default Home;
